import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const TermsModal = ({ isOpen, onClose }) => {
  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          onClick={onClose}
          className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4"
        >
          <motion.div
            initial={{ scale: 0.9, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            exit={{ scale: 0.9, opacity: 0 }}
            onClick={(e) => e.stopPropagation()}
            className="bg-white rounded-lg max-w-2xl max-h-[90vh] overflow-y-auto p-8"
          >
            <div className="flex justify-between items-center mb-6">
              <h2 className="text-3xl font-bold text-gray-900">Terms & Agreement</h2>
              <button
                onClick={onClose}
                className="text-gray-500 hover:text-gray-700 text-2xl"
              >
                ✕
              </button>
            </div>

            <div className="space-y-4 text-gray-700 text-sm leading-relaxed">
              <section>
                <h3 className="font-bold text-lg mb-2 text-gray-900">1. Service Description</h3>
                <p>
                  Ceylon Broker provides digital currency trading services. Our platform allows
                  customers to purchase Bitcoin (BTC), Ethereum (ETH), and Tether (USDT)
                  through a simple,
                  transparent process.
                </p>
              </section>

              <section>
                <h3 className="font-bold text-lg mb-2 text-gray-900">2. Commission Rate</h3>
                <p>
                  <strong>A 10% commission</strong> is charged on all orders. This commission is
                  calculated on the total digital currency value and added to your final amount.
                  The breakdown will be shown before you complete your order.
                </p>
              </section>

              <section>
                <h3 className="font-bold text-lg mb-2 text-gray-900">3. Order Processing</h3>
                <p>
                  After submitting your order:
                </p>
                <ul className="list-disc ml-6 space-y-1 mt-2">
                  <li>We will receive your order details</li>
                  <li>Our team will contact you via phone or email</li>
                  <li>We will confirm the transaction details</li>
                  <li>Payment will be processed according to agreed terms</li>
                </ul>
              </section>

              <section>
                <h3 className="font-bold text-lg mb-2 text-gray-900">4. Security & Privacy</h3>
                <p>
                  Your personal and payment information will be handled securely and kept
                  confidential. We comply with international data protection standards.
                </p>
              </section>

              <section>
                <h3 className="font-bold text-lg mb-2 text-gray-900">5. Digital currency Rates</h3>
                <p>
                  Digital currency rates are updated in real-time from market data. Actual rates
                  
                  may vary slightly at the time of transaction completion.
                </p>
              </section>

              <section>
                <h3 className="font-bold text-lg mb-2 text-gray-900">6. Cancellation Policy</h3>
                <p>
                  Orders can be cancelled before processing begins. Once payment has been
                  initiated, cancellations may incur applicable fees.
                </p>
              </section>

              <section>
                <h3 className="font-bold text-lg mb-2 text-gray-900">7. Liability</h3>
                <p>
                  Ceylon Broker is not responsible for losses due to market volatility,
                  digital currency price changes, or delays in network processing beyond our
                  control.
                </p>
              </section>

              <section>
                <h3 className="font-bold text-lg mb-2 text-gray-900">8. Contact Information</h3>
                <p>
                  For inquiries or support, please contact us through the provided email or
                  phone number on our website.
                </p>
              </section>

              <div className="bg-blue-50 border-l-4 border-blue-500 p-4 mt-6">
                <p className="text-blue-800 font-semibold">
                  By placing an order, you agree to all terms and conditions above.
                </p>
              </div>
            </div>

            <motion.button
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              onClick={onClose}
              className="w-full mt-8 btn-primary"
            >
              I Understand & Accept
            </motion.button>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default TermsModal;
